// extracted by mini-css-extract-plugin
export default {"rotatingBar":"Nav_rotatingBar__XwafM","rotateColors":"Nav_rotateColors__v16a1"};